import { HttpClient } from '@angular/common/http';

import { ApiBase } from '../base';

/**
 * @internal
 */
export class ApiBaseVolume extends ApiBase {
  constructor(protected http: HttpClient) {
    super(http, { backendId: 'volume' });
  }
}
